import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom';

const c3 = require('c3');

class C3Chart extends React.Component {
  componentDidMount() {
    this.updateChart(this.props);
  }

  componentDidUpdate() {
    if (this.props.onPropsChanged) {
      this.props.onPropsChanged(this.props, this.chart);
    }
    this.updateChart(this.props);
  }

  componentWillUnmount() {
    this.destroyChart();
  }

  destroyChart() {
    try {
      this.chart = this.chart.destroy();
    } catch (err) {
      throw new Error('Internal C3 error', err);
    }
  }

  generateChart(mountNode, config) {
    return c3.generate({bindto: mountNode, ...config});
  }

  updateChart(config) {
    if (!this.chart) {
      this.chart = this.generateChart(findDOMNode(this), config);
    }
    if (config.unloadBeforeLoad) {
      this.chart.unload();
    }
    this.chart.load(config.data);
    this.chart.flush();
  }

  render() {
    const className = this.props.className ? ` ${this.props.className}` : '';
    const style = this.props.style ? this.props.style : {};
    return <div className={className} style={style} />;
  }
}

C3Chart.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  title: PropTypes.objectOf(PropTypes.any),
  size: PropTypes.objectOf(PropTypes.any),
  padding: PropTypes.objectOf(PropTypes.any),
  color: PropTypes.objectOf(PropTypes.any),
  interaction: PropTypes.objectOf(PropTypes.any),
  transition: PropTypes.objectOf(PropTypes.any),
  oninit: PropTypes.func,
  onrendered: PropTypes.func,
  onmouseover: PropTypes.func,
  onmouseout: PropTypes.func,
  onresize: PropTypes.func,
  onresized: PropTypes.func,
  axis: PropTypes.objectOf(PropTypes.any),
  grid: PropTypes.objectOf(PropTypes.any),
  regions: PropTypes.arrayOf(PropTypes.any),
  legend: PropTypes.objectOf(PropTypes.any),
  tooltip: PropTypes.objectOf(PropTypes.any),
  subchart: PropTypes.objectOf(PropTypes.any),
  zoom: PropTypes.objectOf(PropTypes.any),
  point: PropTypes.objectOf(PropTypes.any),
  line: PropTypes.objectOf(PropTypes.any),
  area: PropTypes.objectOf(PropTypes.any),
  bar: PropTypes.objectOf(PropTypes.any),
  pie: PropTypes.objectOf(PropTypes.any),
  donut: PropTypes.objectOf(PropTypes.any),
  gauge: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  unloadBeforeLoad: PropTypes.bool,
  onPropsChanged: PropTypes.func,
};

C3Chart.defaultProps = {
  title: null,
  size: null,
  padding: null,
  color: null,
  interaction: null,
  transition: null,
  oninit: () => {},
  onrendered: () => {},
  onmouseover: () => {},
  onmouseout: () => {},
  onresize: () => {},
  onresized: () => {},
  axis: null,
  grid: null,
  regions: [],
  legend: null,
  tooltip: null,
  subchart: null,
  zoom: null,
  point: null,
  line: null,
  area: null,
  bar: null,
  pie: null,
  donut: null,
  gauge: null,
  className: null,
  style: null,
  unloadBeforeLoad: false,
  onPropsChanged: null,
};

export default C3Chart;
